function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProgram = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.263 3H4v11.842h1.466V4.48h8.797V3Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 6.158H7.158v15H19v-15Zm-10.362 1.5h3.7v6l-1.85-1.125-1.85 1.125v-6Z",
  fill: "currentColor"
}));
export default SvgProgram;